import React, { Fragment } from 'react'
import * as Logger from 'loglevel'
import { Table } from 'react-bootstrap'
import { sort, SortOrder, filterSearch, updateDataPublishedTime } from './util/DataHandler'

import TableToolbar from './tools/TableToolbar'
import { css } from '@emotion/core'
import BounceLoader from 'react-spinners/BounceLoader'
import BeatLoader from 'react-spinners/BeatLoader'

import * as HubConstant from './util/HubConstant'
import * as _ from 'lodash'
import Utilities from 'hub-utilities'

// import Authorize from 'components/api-authorization/AuthorizeService';

import '../styles/DataTable.scss'
import '../styles/Calendar.scss'
import UnsavedChangesPopup from './UnsavedChangesPopup'

import NavigationPrompt from 'react-router-navigation-prompt'
import { withRouter, Router } from 'react-router-dom'
import TableRow from './TableRow'
import TableHeader from './TableHeader'

export const TableRowAction = Object.freeze({
  DEFAULT: 0,
  DELETE_ROW: 1,
  CONFIRM_DELETE: 2,
  EDIT_ROW: 2,
  CHANGE_PASSWORD: 3,
  EDIT_INFO_BY_FORM: 4,
  DISABLE: 5,
  EDIT_PRODUCTION_GROUP: 6,
  EDIT_METADATA: 7,
  CHECKBOX: 8,
  ADD_ROW_EDITOR: 9,
  EDIT_ROW_EDITOR: 10,
  DELETE_ROW_VALUE: 11,
  RSS_FEED: 12,
  NAVIGATE_TO: 13,
  IN_PLACE_EDITING: 14,
  POPUP_CONTENT: 15, // customizable popup content
  DOWNLOAD_ALL_MEDIA: 16,
  MOVE_FOLDER_ROW: 17
})

export class DataTable extends React.Component {
  _isMounted = false
  constructor(props) {
    super(props)
    this.state = {
      data: [],
      dataKeys: [],

      sortConfig: { key: null, order: SortOrder.DEFAULT },

      numOfRowsPerPage: HubConstant.HUB_AUTO,
      currentPageNum: 1,
      filterSearchText: '',
      fullTextSearchText: '',
      filteredData: [],

      arrOfJustModifiedRows: [],
      arrOfModifiedRows: [],
      // To cache the index of the sorted data just being edited:
      prevEditedSortedDataCache: { index: -1, val: null },

      hasCollapsibleRows: false,

      // instead of 'hardcoding' array of bools to capture each array, why not instead store an array of expanded IDs
      arrOfExpandedCollapableRowIDs: [],

      // timer to update the page:
      updateFrequencyInSeconds: 5,

      isCollapsedAnimDisabled: false,

      rowHeight: 0,
      numOfRowsToFitViewport: 0,
      currentHeight: 0,
      currentWidth: 0,
      activateAutoRowNum: true,

      activeTableName: null,

      inputAddRowField: '',
      dateAddRowField: new Date(),

      onlyShowDataWithMedia: HubConstant.HUB_CHECKBOX_STATE.NONE,
      onlyShowUrgentData: HubConstant.HUB_CHECKBOX_STATE.NONE,

      // for loading icon:
      inPlaceEditingRows: [], // [{id, val:[{key, val, isCollapsible}]}],
      inPlaceEditingDateRowId: -1,
      isUnsavedChangesPromptOpen: false,

      // array of deleted rows ID:
      locallyDeletedRowIDs: [],

      // only 1 row can be edited at a time
      editingRowIndex: -1,
      numOfCols: 0,

      // for tracking if full text search is active
      isFullTextSearchActive: false 
    }
    this.summaryKeyRefs = []
    this.collapsedKeyRefs = []
    this.cachedObj = [] // if length = 0, for its structure
    // Is deleting is a switch to detect whether row is delete, so that the async setState in componentWillReceiveProps will work correctly:
    this.isDeleting = false

    this.isCollapsedAnimDisabled = false

    this.AuthorizeService = class {
      static getUserGuid() {
        return !!props.authorizeService && !!props.authorizeService.getUserGuid ? props.authorizeService.getUserGuid() : ''
      }

      static getUserType() {
        return !!props.authorizeService && !!props.authorizeService.getUserType ? props.authorizeService.getUserType() : 0
      }

      static getNodeNameByUserGuid() {
        return !!props.authorizeService && !!props.authorizeService.getNodeNameByUserGuid ? props.authorizeService.getNodeNameByUserGuid() : ''
      }

      static getAccessTokenAsync() {
        return !!props.authorizeService && !!props.authorizeService.getAccessTokenAsync ? props.authorizeService.getAccessTokenAsync() : ''
      }
    }
  }

  checkAuthServiceIsInitialized() {
    if (this.props.authorizeService === undefined || this.props.authorizeService.getUserGuid === undefined)
      console.warn( 'AuthorizeService || AuthorizeService.getUserGuid is not initialized as a DataTable Prop. Empty UserGuid is assigned.')
    if (this.props.authorizeService === undefined || this.props.authorizeService.getUserType === undefined)
      console.warn('AuthorizeService || AuthorizeService.getUserType is not initialized as a DataTable Prop. UserType of highest authority is automatically assigned.')
    if (this.props.authorizeService === undefined || this.props.authorizeService.getNodeNameByUserGuid === undefined)
      console.warn('AuthorizeService || AuthorizeService.getNodeNameByUserGuid is not initialized as a DataTable Prop. Empty NodeName is assigned')
  }

  handleWindowBeforeUnload = () => {
    if (this.state.inPlaceEditingRows.length > 0) {
      this.openUnsavedChangesPrompt(false, false)
    }
  }

  componentWillMount() {
    this._isMounted = true

    window.addEventListener('beforeunload', this.handleWindowBeforeUnload)
    Logger.debug('dataAction',this.props.dataAction)
    this.checkAuthServiceIsInitialized()
    if (this._isMounted) {
      this.setState({
        activeTableName: this.props.activeTableName ? this.props.activeTableName : null
      })
    }

    this.setInitialSortConfig()
    if (this._isMounted) {
      this.setState({ data: this.props.data},() => {
        this.setState({ dataKeys: this.setKeys(), cachedObj: this.setCachedObj()}) // setstate is async...
      })
    }
    if (!!this.props.requiredDataType && this.state.data.length > 0) {
      Logger.debug(this.state.data)
      Logger.debug(this.props.requiredDataType)
      this.props.setAreDataOfRightType(
        Utilities.verifyAllVocabsHaveCorrectDataType(
          this.state.data.map((vocab) => vocab.Value.val),
          parseInt(this.props.requiredDataType)
        )
      )
    }

    Logger.debug('MOUNTED')
  }

  //= =======LIVE TIMER REFRESH PAGE==========================================
  // Update Timer:
  startTimer() {
    setInterval(this.countDown, 1000)
  }

  // calls this func every 1000 sec
  countDown = () => {
    // Remove one second, set state so a re-render happens.
    var seconds = this.state.updateFrequencyInSeconds - 1
    if (this._isMounted) this.setState({ updateFrequencyInSeconds: seconds })

    // Check if we're at zero.
    if (this.state.updateFrequencyInSeconds <= 0) this.updatePublishedTime()
  }

  updatePublishedTime() {
    if (this._isMounted)
      this.setState({ data: updateDataPublishedTime(this.state.data), updateFrequencyInSeconds: 5 })
  }

  componentDidMount() {
    this.startTimer()
    if (this.props.history === undefined) {
      Logger.warn(
        "DataTable: This.props.history is undefined, which means Router cannot be detected.  Therefore, Router-dependent functionalities such as in-place editing - unsaved changes prompt won't work."
      )
    }
  }

  componentWillUnmount() {
    this._isMounted = false
    window.removeEventListener('beforeunload', this.handleWindowBeforeUnload)
  }

  AdjustNumOfTableRowsBasedOnScreenSize() {
    // Auto-detect screen size to adjust table rows per page:
    if (
      this.state.activateAutoRowNum &&
      (window.innerHeight !== this.state.currentHeight || window.innerWidth !== this.state.currentWidth)
    ) {
      var header = document.getElementsByClassName('canSort')[0]
      var row = document.getElementsByClassName('data')[0]
      if (!!header && !!row) {
        if (this._isMounted)
          this.setState({ currentHeight: window.innerHeight, currentWidth: window.innerWidth },
            () => {
              const newHeaderHeight = header.clientHeight
              const newRowHeight = row.clientHeight

              var heightOccupied = 0
              var hardcodedConstant = 180
              var tableToolbars = document.getElementsByClassName('TableToolbarTop')
              if (tableToolbars.length > 0) {
                for (var i = 0; i < tableToolbars.length; i++) {
                  heightOccupied += tableToolbars[i].clientHeight
                }
              }

              var numOfRows = Math.max(
                1,
                Math.floor((this.state.currentHeight - heightOccupied - hardcodedConstant - newHeaderHeight) / newRowHeight)
              )
              if (numOfRows < 3) {
                numOfRows = 10 // BUG 437: Auto-size for tables doesn't work for mobile screens "having the default screen size set to 10 seems works well."
              }

              // numOfRowsPerPage can reach infinity for production groups due to rendering order, need to fix later:
              // if (!isFinite(numOfRows))
              //   console.error(
              //     'AutoRowNum Error: NumOfRows is infinity, need to fix later!'
              //   )
              if (this._isMounted)
                this.setState({ numOfRowsPerPage: this.props.numOfRowsPerPage ? this.props.numOfRowsPerPage : isFinite(numOfRows) ? numOfRows : 10 })
            }
          )
      }
    }
  }

  componentDidUpdate() {
    if (this.state.inPlaceEditingRows.length > 0) {
      window.onbeforeunload = () => true
    } else {
      window.onbeforeunload = undefined
    }

    this.AdjustNumOfTableRowsBasedOnScreenSize()
  }

  //= ===================================================================

  // if (!!keyData[key] && !!this.state.data[key]["isInitiallySorted"]) {
  setInitialSortConfig() {
    Object.keys(this.state.dataKeys).forEach((index) => {
      var attr = this.props.headerConfig[this.state.dataKeys[index].key]
      if (!!attr && !!attr.isInitiallySorted) {
        const dataKey = this.state.dataKeys[index].key
        Logger.debug('this.props.data[index]: ', this.props.data[index])
        Logger.debug('dataKey: ', dataKey)
        this.setState({
          sortConfig: {
            key: dataKey,
            order:
              !!this.props.data && !!this.props.data[index] && !!this.props.data[index][dataKey] && !!this.props.data[index][dataKey].initialSortOrder ? this.props.data[index][dataKey].initialSortOrder : SortOrder.ASCENDING
          }
        }, () => Logger.debug(this.state.sortConfig))
      }
    })
  }

  onReloadObjects = (clearSearch) => {
    var searchText = this.state.fullTextSearchText
    if (clearSearch) {
      this.setFullTextSearchText('')
      searchText = ''
    }

    // Node id full-text search is unavailable as of now:
    if (this.props.getNewsItemsByFolder) {
      this.props.getNewsItemsByFolder(this.props.hubWorkingFolder.id, searchText, clearSearch ? HubConstant.HUB_ACTION_STATE.REFRESH : HubConstant.HUB_ACTION_STATE.ELASTIC_SEARCH)
      // this.props.loadNodeContents(0, this.props.objectType, searchText, clearSearch ? HubConstant.HUB_ACTION_STATE.REFRESH : HubConstant.HUB_ACTION_STATE.ELASTIC_SEARCH)
    } else {
      console.error(
        'Please hook up the getNewsItemsByFolder(folderId) to the parent component of DataTable'
      )
    }

    if (this.props.setIsNotificationAllowed) {
      this.props.setIsNotificationAllowed(searchText === '')
    } else {
      console.warn(
        'To allow notifications for ADD_ROW/DELETE_ROW, please add setIsNotificationAllowed(searchText) to the DataTable of parent'
      )
    }
  }

  // To properly map the fetchedData variable to data props:
  componentWillReceiveProps(newProps) {
    Logger.debug('newProps ', newProps)
    Logger.debug('newProps.dataAction ', newProps.dataAction)

    // Also check whether the newProps.data is equal to prev ones
    // check requiredDataType on change of Dropdown:
    if (!!newProps.requiredDataType && newProps.requiredDataType !== this.props.requiredDataType) {
      this.props.setAreDataOfRightType(Utilities.verifyAllVocabsHaveCorrectDataType(this.state.data.map((vocab) => vocab.Value.val), parseInt(newProps.requiredDataType)))
    }
    if (
      this._isMounted &&
      ((!!newProps.data && !!this.state.data && !_.isEqual(newProps.data, this.props.data)) || newProps.dataAction !== this.props.dataAction || newProps.clickNotifier !== this.props.clickNotifier)
    ) {
      var newDataAction = newProps.dataAction
      if (newProps.changeNotifier !== this.props.changeNotifier) {
        newDataAction = HubConstant.HUB_ACTION_STATE.SELECT_CHECKBOX
      }
      // On-click notification button:
      if (this.props.clickNotifier !== undefined && newProps.clickNotifier !== this.props.clickNotifier) {
        this.onReloadObjects(true)
      }
      switch (newDataAction) {
        case HubConstant.HUB_ACTION_STATE.LOADING:
          this.refresh(newProps.data)
          break
        case HubConstant.HUB_ACTION_STATE.ADD_ROW:
          if ( !!newProps.arrOfNewData && newProps.isNotificationAllowed && (this.state.arrOfExpandedCollapableRowIDs.length > 0 || this.state.currentPageNum > 1 || newProps.arrOfNewData.length > 0)
          ) {
            // compare data, then add to n new rows: (notify)            //compare data, then add to n new rows:
            var tempNewDataArr = newProps.data.filter(
              (newData) =>
                !this.props.data.some((oldData) => oldData.id === newData.id)
            )
            const newNewDataArr = newProps.arrOfNewData.concat(tempNewDataArr)
            this.props.setArrOfNewData(newNewDataArr)
          } else {
            // soft-refresh
            Promise.resolve(this.shouldDisableCollapseAnim(true, false)).then(
              (shouldDisableCollapseAnim) => {
                if (shouldDisableCollapseAnim) {
                  this.setState({ data: newProps.data }, () => {
                      this.resortTableThenFilter(this.state.sortConfig.order)
                      this.shouldDisableCollapseAnim(false, false)
                    }
                  )
                }
              }
            )
          }
          break
        case HubConstant.HUB_ACTION_STATE.MOVE_ROW:
        case HubConstant.HUB_ACTION_STATE.DELETE_ROW:
          if (newDataAction === HubConstant.HUB_ACTION_STATE.MOVE_ROW && this.state.isFullTextSearchActive === true){
            Promise.resolve(this.shouldDisableCollapseAnim(true, false)).then(
              (shouldDisableCollapseAnim) => {
                if (shouldDisableCollapseAnim) {
                  this.setState({ data: newProps.data }, () => {
                      this.resortTableThenFilter(this.state.sortConfig.order)
                      this.shouldDisableCollapseAnim(false, false)
                    }
                  )
                }
              }
            )  
            break;
          }
          // Implement array of deleted id on click delete to track down user delete:
          var oldDataObjOfCurrentUserDeletedData = this.props.data.find(
            (dataObj) => {
              return this.state.locallyDeletedRowIDs.includes(dataObj.id)
            }
          )
          if (
            !!newProps.arrOfNewData &&
            newProps.isNotificationAllowed &&
            (this.state.arrOfExpandedCollapableRowIDs.length > 0 || this.state.currentPageNum > 1 || newProps.arrOfNewData.length > 0) &&
            oldDataObjOfCurrentUserDeletedData === undefined
          ) {
            if (newProps.arrOfNewData.length > 0) {
              // compare data, then remove from n new rows:
              const newNewDataArr = newProps.data.filter((newData) =>
                newProps.arrOfNewData.some(
                  (oldData) => oldData.id === newData.id
                )
              )
              this.props.setArrOfNewData(newNewDataArr)
            }
          } else {
            if (oldDataObjOfCurrentUserDeletedData) {
              // Implement array of deleted id on click delete to track down user delete:
              this.setState({
                locallyDeletedRowIDs: this.state.locallyDeletedRowIDs.filter((id) => 
                  id !== oldDataObjOfCurrentUserDeletedData.id
                ),
                arrOfExpandedCollapableRowIDs: this.state.arrOfExpandedCollapableRowIDs.filter((ExpandedCollapableRowId) => 
                  ExpandedCollapableRowId !== oldDataObjOfCurrentUserDeletedData.id
                )
              })
              this.props.setArrOfNewData(
                newProps.arrOfNewData.filter((notificationNewData) => {
                  return (
                    notificationNewData.id ===
                    oldDataObjOfCurrentUserDeletedData.id
                  )
                })
              )
            }

            // soft-refresh
            Promise.resolve(this.shouldDisableCollapseAnim(true, false)).then(
              (shouldDisableCollapseAnim) => {
                if (shouldDisableCollapseAnim) {
                  this.setState({ data: newProps.data}, () => {
                      this.resortTableThenFilter(this.state.sortConfig.order)
                      // TEST:
                      this.shouldDisableCollapseAnim(false, false)
                    })
                }
              }
            )
          }
          break
        case HubConstant.HUB_ACTION_STATE.NONE:
          if (this.props.isForm === undefined || !this.props.isForm) break
        /* falls through */
        case HubConstant.HUB_ACTION_STATE.INITIALIZE:
          this.setInitialSortConfig()
          this.setState({ currentPageNum: 1 })
        case HubConstant.HUB_ACTION_STATE.EXPAND_ROW:
          this.setInitialSortConfig()
        /* falls through */
        case HubConstant.HUB_ACTION_STATE.SELECT_CHECKBOX:
        case HubConstant.HUB_ACTION_STATE.REFRESH:
        /* falls through */
        case HubConstant.HUB_ACTION_STATE.ELASTIC_SEARCH:
        case HubConstant.HUB_ACTION_STATE.FILTER:
          if ( newDataAction === HubConstant.HUB_ACTION_STATE.ELASTIC_SEARCH || newDataAction === HubConstant.HUB_ACTION_STATE.FILTER ) {
            // refresh:
            this.props.setArrOfNewData([])
            this.setState({ currentPageNum: 1 })
          }
          this.setState({ data: newProps.data }, () => {
            this.resortTableThenFilter(this.state.sortConfig.order)
            // TEST:
            this.shouldDisableCollapseAnim(false, false)
          })
          break
        case HubConstant.HUB_ACTION_STATE.MODIFY_ROW:
          // perhaps, edit data delivered? But NOT deactivate/activate user
          var modifiedData = newProps.data.find((newD) =>
            this.state.data.some((oldD) => newD.id === oldD.id && !_.isEqual(newD, oldD) && !(!!newD.State && newD.State.val !== oldD.State.val))
          )
          if (modifiedData) {
            // edit data delivered confirmed:
            this.setState({ data: newProps.data}, () => {
            if (this.addToArrOfJustModifiedRows(modifiedData))
              this.resortTableThenFilter(this.state.sortConfig.order)
            })
          } else {
            // deactivate/activate user
            modifiedData = newProps.data.find((newD) =>
              this.state.data.some((oldD) => !!newD.State && newD.State.val !== oldD.State.val)
            )
            if (modifiedData) {
              // edit data delivered confirmed:
              this.setState({ data: newProps.data}, () => {
                this.resortTableThenFilter(this.state.sortConfig.order)
              })
            }
          }
          break
        default:
          break
      }
    }
  }

  refresh(newdata) {
    if (
      this.state.filteredData.length !== 0 ||
      this.state.data.length !== 0 ||
      this.state.arrOfExpandedCollapableRowIDs.length !== 0 ||
      this.state.inPlaceEditingRows.length !== 0 ||
      this.state.inPlaceEditingDateRowId !== -1 ||
      this.state.locallyDeletedRowIDs.length !== 0
    )
      this.setState({
        filteredData: [],
        data: newdata,
        arrOfExpandedCollapableRowIDs: [],
        inPlaceEditingRows: [],
        inPlaceEditingDateRowId: -1,
        locallyDeletedRowIDs: []
      })
  }

  initialiseCollapsedBools() {
    var collapsedBools = []
    for (var i = 0; i < this.state.data.length; i++) {
      collapsedBools.push(false)
    }
    return collapsedBools
  }

  setKeys() {
    var sk = []
    var keyData = !!this.state.data && !!this.state.data[0] ? this.state.data[0] : this.props.headerConfig

    Logger.debug(keyData)
    if (keyData) {
      Object.keys(keyData).forEach((key, index) => {
        // if (typeof(this.state.data[0][key]) !=='object') {//to prevent details being mapped

        if (key !== 'Collapsible') {
          // to prevent details being mapped
          sk.push({
            key: key,
            ...(!!keyData[key] && keyData[key].canSort !== undefined && {
                canSort: keyData[key].canSort
              }),
            ...(!!keyData[key] && keyData[key].shouldShowCheckbox !== undefined && {
                shouldShowCheckbox: keyData[key].shouldShowCheckbox
              }),
            ...(!!keyData[key] && keyData[key].hasRowIcon !== undefined && {
                hasRowIcon: keyData[key].hasRowIcon
              }),
            ...(!!keyData[key] && keyData[key].headerIcon !== undefined && {
                headerIcon: keyData[key].headerIcon
              })
          })
        } else {
          this.setState({ hasCollapsibleRows: true })
        }
      })
    }
    return sk
  }

  // POSSIBLE TEST CASE:
  // Set Cached object for length = 0, so that the table header isn't gone when there are no data
  setCachedObj() {
    var newObjArr = []
    var cachedData = this.props.headerConfig
    newObjArr.push(cachedData)
    return newObjArr
  }

  sortTable = (indexStr, sortOrder) => {
    // better to just pass in a simple parameter for callbacks
    return new Promise(async (resolve, reject) => {
      var key = ''
      if (this.state.dataKeys[parseInt(indexStr)]) {
        key = this.state.dataKeys[parseInt(indexStr)].key
      } else if (indexStr.includes('resortTable')) {
        key = indexStr.replace('resortTable', '')
      } else {
        resolve(true)
      }
      var newData = await this.setStateThenSort(this.state.data, key, sortOrder)

      if (newData) {
        this.setState({ data: newData }, () => { resolve(true) })
      } else {
        resolve(false)
      }
    })
  }

  // Have to await this promise to return, as sortConfig setState causes the sort to be async
  // Or else returns undefined nonetheless
  setStateThenSort(data, key, order) {
    return new Promise((resolve, reject) => {
      this.setState({ sortConfig: { key: key, order: order }}, () => {
        resolve(sort(data, key, this.state.sortConfig, this.state.arrOfJustModifiedRows, this.state.arrOfModifiedRows))
      })
      if (key === undefined) reject('some error')
    })
  }

  setLocallyDeletedRowIDs = (locallyDeletedRowIDs) => {
    return new Promise((resolve, reject) => {
      this.setState({ locallyDeletedRowIDs: locallyDeletedRowIDs }, () =>
        resolve(true)
      )
    })
  }

  setIsCollapsedAnimDisabled = (isDisabled) => {
    Logger.debug("setIsCollapsedAnimDisabled inside start")
    return new Promise((resolve, reject) => {
      this.setState({ isCollapsedAnimDisabled: isDisabled }, () =>
        resolve(true)
      )
    })
    
  }

  setArrOfExpandedCollapableRowIDs = (arrOfExpandedCollapableRowIDs) => {
    return new Promise((resolve, reject) => {
      this.setState(
        { arrOfExpandedCollapableRowIDs: arrOfExpandedCollapableRowIDs },
        () => resolve(true)
      )
    })
  }

  setInPlaceEditingDateRowId = (id) => {
    return new Promise((resolve, reject) => {
      this.setState({ inPlaceEditingDateRowId: id }, () => resolve(true))
    })
  }

  setEditingRowIndex = (index) => {
    return new Promise((resolve, reject) => {
      this.setState({ editingRowIndex: index }, () => resolve(true))
    })
  }

  setInPlaceEditingRows = (index) => {
    return new Promise((resolve, reject) => {
      this.setState({ editingRowIndex: index }, () => resolve(true))
    })
  }

  generateTableRowData(data, dataObj, index) {
    return (
      <TableRow
        data={data}
        folder={this.props.folder}
        filteredData={this.state.filteredData}
        dataObj={dataObj}
        dataKeys={this.state.dataKeys}
        index={index}
        arrOfJustModifiedRows={this.state.arrOfJustModifiedRows}
        arrOfModifiedRows={this.state.arrOfModifiedRows}
        hasCollapsibleRows={this.state.hasCollapsibleRows}
        isCollapsedAnimDisabled={this.state.isCollapsedAnimDisabled}
        arrOfExpandedCollapableRowIDs={this.state.arrOfExpandedCollapableRowIDs}
        setArrOfExpandedCollapableRowIDs={this.setArrOfExpandedCollapableRowIDs}
        inPlaceEditingRows={this.state.inPlaceEditingRows}
        setInPlaceEditingRows={this.setInPlaceEditingRows}
        inPlaceEditingDateRowId={this.state.inPlaceEditingDateRowId}
        setInPlaceEditingDateRowId={this.setInPlaceEditingDateRowId}
        editingRowIndex={this.state.editingRowIndex}
        setEditingRowIndex={this.setEditingRowIndex}
        loading={this.state.loading}
        openUnsavedChangesPrompt={this.openUnsavedChangesPrompt}
        onOpenForm={this.onOpenForm}
        onDeleteObjectClick={this.props.onDeleteObjectClick}
        authorizeService={this.AuthorizeService}
        currentPageNum={this.state.currentPageNum}
        numOfRowsPerPage={this.state.numOfRowsPerPage}
        numOfCols={this.state.numOfCols}
        locallyDeletedRowIDs={this.state.locallyDeletedRowIDs}
        setLocallyDeletedRowIDs={this.setLocallyDeletedRowIDs}
        setIsCollapsedAnimDisabled={this.setIsCollapsedAnimDisabled}
        isFullTextSearchActive={this.state.isFullTextSearchActive}
        dataAction={this.props.dataAction}
        {...this.props}
      />
    )
  }

  generateTableBody() {
    const data = this.getFilteredData()
    // for each array elem generate tr
    return (
      <Fragment key={`tbody_Fragment${data.id}`}>
        <tbody key={`tbody${data.id}`} className='parent-tbody'>
          {this.props.isPageless !== undefined && this.props.isPageless
            ? data.map((dataObj, index) => {
                return this.generateTableRowData(data, dataObj, index)
              })
            : data
                .slice(
                  (this.state.currentPageNum - 1) * this.state.numOfRowsPerPage,
                  data.length > this.state.currentPageNum * this.state.numOfRowsPerPage? this.state.currentPageNum * this.state.numOfRowsPerPage : data.length
                )
                .map((dataObj, index) => {
                  return this.generateTableRowData(data, dataObj, index)
                })}
        </tbody>
      </Fragment>
    )
  }

  // for input add row: ========================================================================

  disableAddVocabInput() {
    if (this.props.isInputDisabled) return 'disabled'
    if (this.props.isDateTime) {
      if (this.state.dateAddRowField == null) {
        return 'disabled'
      }
    } else {
      if (this.state.inputAddRowField === '') {
        return 'disabled'
      }
    }
    return ''
  }

  addToArrOfJustModifiedRows(dataObj) {
    return new Promise((resolve, reject) => {
      var newArrOfJustModifiedRows = this.state.arrOfJustModifiedRows
      const newDataSortedDataCacheObj = Object.assign({}, this.state.prevEditedSortedDataCache)
      newArrOfJustModifiedRows.push(newDataSortedDataCacheObj)

      // Remove if it's modified for re-newing the row:
      var newArrOfModifiedRows = this.state.arrOfModifiedRows.filter((elem) => elem.val.id !== dataObj.id)

      this.setState({ arrOfJustModifiedRows: newArrOfJustModifiedRows, arrOfModifiedRows: newArrOfModifiedRows }, () => { resolve(true) })
    })
  }

  shouldDisableCollapseAnim = (bShouldDisable, bIsPagniation) => {
    return new Promise((resolve, reject) => {
      var newIsCollapsedAnimDisabled = bShouldDisable

      if (bIsPagniation) {
        setTimeout(() => {
          this.setState({ isCollapsedAnimDisabled: true}, () => { this.setState({ isCollapsedAnimDisabled: false }) })
        }, 1000)
      } else {
        if (bShouldDisable) {
          this.setState({ isCollapsedAnimDisabled: newIsCollapsedAnimDisabled}, () => { resolve(true)})
        } else {
          setTimeout(() => this.setState({ isCollapsedAnimDisabled: newIsCollapsedAnimDisabled}, () => { resolve(true) }), 1000)
        }
      }
    })
  }

  DisableCollapseAnim(bShouldDisable) {
    if (bShouldDisable) {
      return new Promise((resolve, reject) => {
        var newIsCollapsedAnimDisabled = bShouldDisable
        this.setState({ isCollapsedAnimDisabled: newIsCollapsedAnimDisabled}, () => { resolve(true) })
      })
    } else {
      // Need to set 1 second delay to ensure bootstrap anim isn't played
      return new Promise((resolve, reject) => {
        var newIsCollapsedAnimDisabled = bShouldDisable
        setTimeout(() => this.setState({ isCollapsedAnimDisabled: newIsCollapsedAnimDisabled},() => { resolve(true) }), 1000)
      })
    }
  }

  setNumOfCols = (numOfCols) => {
    this.setState({ numOfCols: numOfCols })
  }

  generateTableHeader() {
    return (
      <TableHeader
        filteredData={this.state.filteredData}
        data={this.state.data}
        currentPageNum={this.state.currentPageNum}
        numOfRowsPerPage={this.state.numOfRowsPerPage}
        sortConfig={this.state.sortConfig}
        hasCollapsibleRows={this.state.hasCollapsibleRows}
        dataKeys={this.state.dataKeys}
        numOfCols={this.state.numOfCols}
        setNumOfCols={this.setNumOfCols}
        authorizeService={this.AuthorizeService}
        resortTableThenFilterByKey={this.resortTableThenFilterByKey}
        {...this.props}
      />
    )
  }

  generateTable() {
    if (this.state.data.length > 0) {
      return (
        <Table bordered hover className='generatedTable'>
          {this.generateTableHeader()}
          {this.generateTableBody()}
        </Table>
      )
    } else {
      return (
        <Fragment>
          <Table bordered hover className='generatedTable'>
            {this.generateTableHeader()}
          </Table>
          {this.props.dataAction === HubConstant.HUB_ACTION_STATE.LOADING ? ( this.gerenateLoader() ) : ( <Fragment /> )}
        </Fragment>
      )
    }
  }

  gerenateLoader() {
    const clockLoaderOverride = css`
      display: block;
      margin-top: 30px;
      margin: auto;
    `
    const beatLoaderOverride = css`
      display: inline-block;
      vertical-align: -webkit-baseline-middle;
      margin-left: -6px;
    `
    return (
      <div className='TableLoader'>
        <BounceLoader css={clockLoaderOverride} size={150} color='#ffbb33' loading={this.state.loading} />

        <div className='LoaderText'>
          <div className='Text'>Loading</div>{' '}
          <BeatLoader css={beatLoaderOverride} size={20} color='#ffbb33' loading={this.state.loading} />
        </div>
      </div>
    )
  }

  setNumOfRowsPerPage = (numOfRowsPerPage) => {
    if (numOfRowsPerPage === HubConstant.HUB_AUTO) {
      // re-initialize the window sizes:
      this.setState({ currentHeight: -1, currentWidth: -1 }, () =>
          this.setState({ activateAutoRowNum: true })
      )
    } else {
      this.setState({
        numOfRowsPerPage: this.props.numOfRowsPerPage ? this.props.numOfRowsPerPage : numOfRowsPerPage,
        activateAutoRowNum: false
      })
    }
  }

  setCurrentPageNum = (currentPageNum) => {
    this.setState({ currentPageNum: currentPageNum })
  }

  setIsFullTextSearchActive = (isFullTextSearchActive) => {
    this.setState({isFullTextSearchActive: isFullTextSearchActive})
  }

  // new to do this on flush, delete and add data...
  async resortTableThenFilter(sortOrder) {
    var newKey = this.state.sortConfig.key
    // need to set the sortorder to opposite way first as the main sorting function inverts sortorder itself:
    this.setState({ sortConfig: { key: newKey, order: sortOrder }}, async () => {
        if (!!this.state.sortConfig.key && sortOrder !== SortOrder.DEFAULT) {
          if (await this.sortTable(this.state.dataKeys.findIndex((dk) => dk.key === newKey).toString().concat('resortTable'), sortOrder)) {
            await this.setFilterSearchText(this.state.filterSearchText)
          }
        } else {
          // if sort isn't necessary, in this sense, sortConfig isn't set:
          await this.setFilterSearchText(this.state.filterSearchText)
        }
      }
    )
  }

  // new to do this on flush, delete and add data...
  resortTableThenFilterByKey = async (key, sortOrder) => {
    // need to set the sortorder to opposite way first as the main sorting function inverts sortorder itself:
    this.setState({ sortConfig: { key: key, order: sortOrder } }, async () => {
        if (this.state.sortConfig.key) {
          if (await this.sortTable(key, sortOrder)) {
            await this.setFilterSearchText(this.state.filterSearchText)
          }
        } else {
          // if sort isn't necessary, in this sense, sortConfig isn't set:
          await this.setFilterSearchText(this.state.filterSearchText)
        }
      })
  }

  // If not in first page:
  flushNewDataCount = () => {
    // Issue: Page lags on page navigation, due to the need of removing newly-added rows,
    // and re-sort them:
    // Solution: Check the length of those lists, if empty then don't flush:
    if (this.state.arrOfJustModifiedRows.length > 0 || this.state.arrOfModifiedRows.length > 0) {
      this.setState({ arrOfJustModifiedRows: [], arrOfModifiedRows: []}, () => {
          this.resortTableThenFilter(this.state.sortConfig.order)
        })
    }
  }

  // Filter text:
  setFilterSearchText = (text) => {
    return new Promise((resolve, reject) => {
      this.setState({ filterSearchText: text }, () => {
          var newData = filterSearch(this.state.data, this.state.filterSearchText)
          this.setState({ filteredData: newData},() => { resolve(true) })
        })
    })
  }

  // Full Text Search text:
  setFullTextSearchText = (text) => {
    return new Promise((resolve, reject) =>
      this.setState({ fullTextSearchText: text }, () => resolve(true))
    )
  }

  setOnlyShowDataWithMedia = (shouldShow) => {
    this.setState({ onlyShowDataWithMedia: shouldShow })
  }

  setOnlyShowUrgentData = (shouldShow) => {
    this.setState({ onlyShowUrgentData: shouldShow })
  }

  // Open new form on new row action:
  onOpenForm = (formType, rowAction, dataObj) => {
    if (this.props.onOpenForm === undefined) {
      Logger.error(
        'Please install hub-form npm module to open form.  Also add onOpenForm() as a DataTable props!'
      )
      return
    }
    switch (rowAction) {
      // case HubConstant.HUB_CREATE_NEW_USER_FORM:
      //   this.props.onOpenForm(formType, this.props.objectType, null);
      //   break;
      case TableRowAction.CHANGE_PASSWORD:
      case TableRowAction.EDIT_INFO_BY_FORM:
      case TableRowAction.EDIT_METADATA:
        // this.props.editMetadata(); //reset error msg TODO: Need to solve such redux dependency issue
        this.props.onOpenForm(formType, this.props.objectType, dataObj)
        this.setState({
          prevEditedSortedDataCache: {
            index: this.state.data.findIndex((elem) => dataObj.id === elem.id),
            val: dataObj
          }
        })
        break
      case TableRowAction.EDIT_ROW: // update newsitem metadata
        this.props.onOpenForm(formType, this.props.objectType, dataObj)
        this.setState({
          prevEditedSortedDataCache: {
            index: this.state.data.findIndex((elem) => dataObj.id === elem.id),
            val: dataObj.id
          }
        })
        break
      case TableRowAction.EDIT_PRODUCTION_GROUP:
        if (!!dataObj.Members && !!dataObj.Members.formVal && !!this.props.nodeData) {
          // this.props.editNodeGroup(); //reset error msg TODO: Need to solve such redux dependency issue
          this.props.onOpenForm(formType, this.props.objectType, { data: dataObj,nodeData: this.props.nodeData })
          this.setState({
            prevEditedSortedDataCache: { 
              index: this.state.data.findIndex((elem) => dataObj.id === elem.id),
              val: { data: dataObj, nodeData: this.props.nodeData }
            }
          })
        }
        break
      default:
        break
    }
  }

  getFilteredData() {
    var chosenData = this.state.filteredData.length > 0 ? this.state.filteredData : this.state.filterSearchText === '' ? this.state.data : this.state.filteredData
    if (this.state.data === undefined) chosenData = []
    return chosenData
  }

  // so apparently, I have to bind the data to the data STATE, instead of this.props.data from the story
  // or else half way through, there would be data desync issues between parent and child..

  onSaveUnsavedChangesPrompt = (onSave) => {
    if (this.props.onSaveAllInPlaceEditings) {
      this.props.onSaveAllInPlaceEditings(this.state.inPlaceEditingRows)
    } else {
      Logger.error('DataTable: this.props.onSaveAllInPlaceEditings is needed for alerting unsaved changes!')
    }

    // For Toolbar actions like refresh/elastic search:
    if (this.state.shouldRefreshAfterPromptConfirm) {
      this.onReloadObjects(this.state.shouldClearSearchAfterPromptConfirm)
    }

    this.setState({ isUnsavedChangesPromptOpen: false, shouldClearSearchAfterPromptConfirm: false, shouldRefreshAfterPromptConfirm: false })
    if (onSave) onSave()
  }

  onDiscardUnsavedChangesPrompt = (onDiscard) => {
    this.setState({ isUnsavedChangesPromptOpen: false, inPlaceEditingRows: [] })
    if (onDiscard) onDiscard()
  }

  onCancelUnsavedChangesPrompt = (onCancel) => {
    this.setState({ isUnsavedChangesPromptOpen: false })
    if (onCancel) onCancel()
  }

  renderUnsavedChangesPrompt(onSave, onDiscard, onCancel, isOpen) {
    return (
      <UnsavedChangesPopup
        unsavedItemNames={this.state.inPlaceEditingRows.map((editingRow) => editingRow.name)}
        onSave={() => this.onSaveUnsavedChangesPrompt(onSave)}
        onDiscard={() => this.onDiscardUnsavedChangesPrompt(onDiscard)}
        onCancel={() => this.onCancelUnsavedChangesPrompt(onCancel)}
        isOpen={isOpen}
      />
    )
  }

  openUnsavedChangesPrompt = (isRefresh, clearSearch) => {
    // check this for refresh/elastic search:
    if (this.state.inPlaceEditingRows.length > 0) {
      this.setState({ isUnsavedChangesPromptOpen: true, shouldClearSearchAfterPromptConfirm: clearSearch, shouldRefreshAfterPromptConfirm: isRefresh })
    } else {
      this.onReloadObjects(this.state.shouldClearSearchAfterPromptConfirm)
      this.setState({ shouldClearSearchAfterPromptConfirm: false, shouldRefreshAfterPromptConfirm: false })
    }
  }

  onNavigation_RenderUnsavedChangesPrompt() {
    return (
      <NavigationPrompt when={this.state.inPlaceEditingRows.length > 0}>
        {({ onConfirm, onCancel }) =>
          this.renderUnsavedChangesPrompt(onConfirm, onConfirm, onCancel, true)
        }
      </NavigationPrompt>
    )
  }

  renderDataTableComponent() {
    return (
      <Fragment>
        <div className='DataTable'>
          <div className='TableContent'>
            <TableToolbar
              part='top'
              activePageName={this.props.activePageName}
              setActivePageName={this.props.setActivePageName}
              activeTableName={this.state.activeTableName}
              numOfRowsPerPage={this.state.numOfRowsPerPage}
              setNumOfRowsPerPage={this.setNumOfRowsPerPage}
              filterSearchText={this.state.filterSearchText}
              setFilterSearchText={this.setFilterSearchText}
              fullTextSearchText={this.state.fullTextSearchText}
              setFullTextSearchText={this.setFullTextSearchText}
              tools={this.props.tools}
              data={this.getFilteredData()}
              onOpenForm={this.props.onOpenForm}
              loadNodeContents={this.props.loadNodeContents}
              getNewsItemsByFolder={this.props.getNewsItemsByFolder}
              folder={this.props.folder}
              isFullTextSearchActive={this.state.isFullTextSearchActive}
              setIsFullTextSearchActive={this.setIsFullTextSearchActive}
              onReloadObjects={this.onReloadObjects}
              objectType={
                this.props.secondaryObjectType
                  ? this.props.secondaryObjectType
                  : this.props.objectType
              }
              onDeleteSelectedValues={this.props.onDeleteSelectedValues}
              setOnlyShowDataWithMedia={this.setOnlyShowDataWithMedia}
              setOnlyShowUrgentData={this.setOnlyShowUrgentData}
              dataType={this.props.requiredDataType}
              isRightDataType={
                !!this.getFilteredData()[0] && !!this.getFilteredData()[0].Value
                  ? Utilities.verifyAllVocabsHaveCorrectDataType(
                      this.getFilteredData().map(
                        (dataObj) => dataObj.Value.val
                      ),
                      parseInt(this.props.requiredDataType)
                    )
                  : undefined
              }
              // Vocab:
              onSubmitTableToolbarEditor={this.props.onSubmitTableToolbarEditor}
              // filter bar:
              filterBarConfig={this.props.filterBarConfig}
              message={this.props.message}
              // data concurrency issues fix:
              isLoading={
                this.props.dataAction === HubConstant.HUB_ACTION_STATE.LOADING
              }
              setIsNotificationAllowed={this.props.setIsNotificationAllowed}
              openUnsavedChangesPrompt={this.openUnsavedChangesPrompt}
            />

            {this.generateTable()}
            <TableToolbar
              part='bottom'
              activePageName={this.props.activePageName}
              activeTableName={this.state.activeTableName}
              shouldDisableCollapseAnim={this.shouldDisableCollapseAnim}
              isRefreshing={this.props.dataAction}
              numOfRowsPerPage={this.state.numOfRowsPerPage}
              setNumOfRowsPerPage={this.setNumOfRowsPerPage}
              currentPageNum={this.state.currentPageNum}
              setCurrentPageNum={this.setCurrentPageNum}
              flushNewDataCount={this.flushNewDataCount}
              tools={this.props.tools}
              data={this.getFilteredData()}
              onOpenForm={this.props.onOpenForm}
              loadNodeContents={this.props.loadNodeContents}
              objectType={this.props.secondaryObjectType ? this.props.secondaryObjectType : this.props.objectType}
              dataAction={this.props.dataAction}
            />
          </div>
        </div>
      </Fragment>
    )
  }

  render() {
    if (this.props.data) {
      return this.props.history ? (
        <Router history={this.props.history}>
          {this.renderUnsavedChangesPrompt(
            this.onSaveUnsavedChangesPrompt,
            null,
            null,
            this.state.isUnsavedChangesPromptOpen
          )}
          {this.onNavigation_RenderUnsavedChangesPrompt()}
          {this.renderDataTableComponent()}
        </Router>
      ) : (
        this.renderDataTableComponent()
      )
    } else return <></>
  }
}

export default withRouter(DataTable)
